// extracted by mini-css-extract-plugin
export var layoutContainer = "_b7-0";
export var layoutContainerNoRounding = "_b7-6";
export var layoutContainerOpen = "_b7-5";
export var layoutContainerResizing = "_b7-1";
export var mainContent = "_b7-2";
export var resizeDivider = "_b7-3";
export var slidePanel = "_b7-4";